module.exports = __webpack_public_path__ + "img/icon_mouse_dongle.abdaed41.svg";